import React, { useContext, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { MediaContext } from '../context/MediaContext';
import { uploadFile } from '../services/FileServices';
import styles from "./../pages/Table.module.css";
import './MediaItems.css';

const MediaItems = ({ projectSlug, objectType, objectSlug }) => {
    const { mediaItems, addMedia, getMediaReference, updateMedia, deleteMedia } = useContext(MediaContext);
    const [error, setError] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [formData, setFormData] = useState({
        type: 'image',
        file: null,
        extension: '',
        url: ''
    });
    const [updateCounter, setUpdateCounter] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);

    const clearMedia = () => {
        setFormData({ type: 'image', file: null, extension: '', url: '' });
        setSelectedItem(null);
        if (fileInputRef.current) fileInputRef.current.value = '';
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    };

    const fileInputRef = React.useRef(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const extension = file.name.split('.').pop();
                setFormData({ ...formData, file: reader.result, extension: extension, url: '' });
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); 
        setError(null);

        if (!formData.file && !formData.url) {
            setError("Por favor, proporciona un archivo o una URL.");
            return;
        }

        try {
            let reference = (selectedItem) ? selectedItem.reference : getMediaReference(formData.type);
            let uploadedUrl = formData.url;
            if (formData.file) {
                const data = {
                    projectSlug,
                    objectType,
                    objectSlug,
                    reference,
                    fileContent: formData.file,
                    fileExtension: formData.extension,
                };
                uploadedUrl = await uploadFile(data);
            }

            const newItem = {
                type: formData.type,
                reference,
                url: uploadedUrl
            };
            if (selectedItem) {
                updateMedia(selectedItem.reference, newItem);
            } else {
                addMedia(newItem);
            }

            setUpdateCounter(c => c + 1);
            clearMedia();
        } catch (error) {
            setError(error.message);
        }
    };

    const handleEdit = (item) => {
        setSelectedItem(item);
        setFormData({ type: item.type, file: null, extension: '', url: item.url });
    };

    const handleDelete = (id) => {
        setItemToDelete(id);
        setShowDeleteModal(true);
    };

    const confirmDelete = () => {
        if (itemToDelete) {
            deleteMedia(itemToDelete);
            setItemToDelete(null);
            setShowDeleteModal(false);
        }
    };

    const cancelDelete = () => {
        setItemToDelete(null);
        setShowDeleteModal(false);
    };

    useEffect(() => { }, [updateCounter]);

    return (
        <div className="media-container">
            <h2>Multimedia</h2>            
            <button className="btn-add" onClick={() => { clearMedia(); setShowModal(true); }}>
                <FontAwesomeIcon icon={faPlus} />
            </button>

            {error && <div className="error-message">{error}</div>}

            <table className={styles.table}>
                <thead>
                    <tr>
                        <th>Referencia</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {mediaItems.map(item => (
                        <tr key={item.reference}>
                            <td>{item.reference}</td>
                            <td>
                                <div className="actions-container">
                                    <button className="btn-edit" onClick={() => { handleEdit(item); setShowModal(true); }}>
                                        <FontAwesomeIcon icon={faPencilAlt} />
                                    </button>
                                    <button className="btn-delete" onClick={() => handleDelete(item.reference)}>
                                        <FontAwesomeIcon icon={faTrashAlt} />
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>


            {showModal && (
                <div className="media-modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="media-modal" onClick={e => e.stopPropagation()}>
                        <h3>{selectedItem ? 'Editar multimedia' : 'Agregar multimedia'}</h3>
                        <form className="media-form" key={updateCounter} onSubmit={async (e) => { await handleSubmit(e); setShowModal(false); }}>
                            <label>
                                Tipo:
                                <select
                                    name="type"
                                    value={formData.type}
                                    onChange={handleInputChange}
                                    className="input-select"
                                >
                                    <option value="image">Imagen</option>
                                    <option value="rotator">OrbitView</option>
                                    <option value="virtualTour">Tour Virtual</option>
                                    <option value="isometric">Isometría</option>
                                    <option value="layout">Planos</option>
                                    <option value="measurements">Medidas</option>
                                    <option value="floorPlan">Render Planta</option>
                                    <option value="view">Vista</option>
                                    <option value="map">Mapa</option>
                                    <option value="other">Otro</option>
                                </select>
                            </label>

                            <label>
                                Seleccione un archivo:
                                <input type="file" ref={fileInputRef} onChange={handleFileChange} className="input-file" />
                            </label>

                            <label>
                                URL:
                                <input
                                    type="text"
                                    name="url"
                                    value={formData.url}
                                    onChange={handleInputChange}
                                    className="input-text"
                                    disabled={formData.file !== null}
                                />
                            </label>

                            <div className="form-actions">
                                <button type="submit" className="btn-confirm">Enviar</button>
                                <button type="button" className="btn-cancel" onClick={() => setShowModal(false)}>Cancelar</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {showDeleteModal && (
                <div className="media-modal-overlay" onClick={cancelDelete}>
                    <div className="media-modal" onClick={e => e.stopPropagation()}>
                        <h3>¿Seguro que deseas eliminar este archivo?</h3>
                        <div style={{ display: "flex", gap: "10px", marginTop: "20px", justifyContent: "center" }}>
                            <button className="btn-confirm" onClick={confirmDelete}>Aceptar</button>
                            <button className="btn-cancel" onClick={cancelDelete}>Cancelar</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MediaItems;
